import { Injectable } from '@angular/core';

import { Browser } from '@capacitor/browser';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  constructor(
  ) {
  }

  create(
    url: string,
  ) {
    return new Promise(async (resolve, reject) => {
      url = url || '';

      if (!!url) {

        if (url.indexOf('http') !== 0) {
          url = `http://${url}`;
        }

        const browser: any = await Browser.open({
          url: url,
          //toolbarColor: '#6e52fb',
          presentationStyle: 'popover',
        });

        resolve(true);
      }
    });
  }

}
